import {LocalStorageService} from "./local-storage-service";
import {Branding} from "./branding-service";

/**
 * Sekme başlığındaki uygulama adı — 18 sayfa bunu çağırıyor.
 * Kaynak artık configuration.json değil MARKA (DB): beyaz etiket kurulumunda kiracının başlığı,
 * yoksa gömülü varsayılan ("RIS · eCloudPACS").
 */
const getRisTitle = () => {
    return Branding.title(LocalStorageService.getLanguage('tr'))
}

const AppConfig = {
    getRisTitle
}

export default AppConfig;
